<template>
  <div class="content billing_sec">
    <PulseLoader :loading="!loaded" :class="{hide: loaded}" quote="Action is the foundational key to all success" author="Pablo Picasso" profession="Spanish Painter" img="picasso.jpg"></PulseLoader>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100"
      >
        <nav aria-label="breadcrumb" role="navigation">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: defaultScreen }"> Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'BillingAndInvoices' }">
                Billing and Invoices
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Transaction Details
            </li>
          </ol>
        </nav>
        <div class="navbar md-toolbar md-transparent md-elevation-4">
          <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
              <h1 class="md-title">
                Transaction Details
              </h1>
            </div>
            <div class="md-toolbar-section-end" v-if="loaded && transaction">
              <div class="links">
                <md-button
                  class="md-raised md-info mt-4"
                  @click="getTransactionPDF()"
                  ><md-icon>save_alt</md-icon>Download Invoice</md-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- <div>
          <pulse-loader :color="'blue'" :loading="!loaded"></pulse-loader>
        </div> -->
      </div>
    </div>

    <div class="md-layout" v-if="loaded">
      <div class="md-layout-item md-size-100">
        <table-card>
          <template v-if="transaction">
            <template slot="header">
              <div class="card-icon">
                <md-icon>receipt_long</md-icon>
              </div>
              <h4 class="title">Transaction No: #{{ transaction.trans_id }}</h4>
            </template>

            <template slot="content">
              <div class="md-layout">
                <div class="md-layout-item md-size-25">
                  <h4 class="card-title"><b>Order Placed</b></h4>
                  <p>
                    {{
                      transaction.insert_date
                        | moment('dddd Do MMMM YYYY h:mm A')
                    }}
                  </p>
                </div>
                <div class="md-layout-item md-size-25">
                  <h4 class="card-title"><b>Name</b></h4>
                  <p>
                    {{ user.firstName + ' ' + user.lastName }}
                  </p>
                </div>
                <div class="md-layout-item md-size-25">
                  <h4 class="card-title"><b>Email</b></h4>
                  <p>{{ user.email }}</p>
                </div>
                <div class="md-layout-item md-size-25">
                  <h4 class="card-title"><b>Phone</b></h4>
                  <p>
                    {{
                      user.phoneNumber && user.phoneNumber !== "''"
                        ? user.phoneNumber
                        : 'N/A'
                    }}
                  </p>
                </div>
                <div class="md-layout-item md-size-25">
                  <h4 class="card-title"><b>Billing Address</b></h4>
                  <p>
                    {{
                      (user.streetAddres && user.streetAddress !== "''"
                        ? user.streetAddress + ', '
                        : '') +
                        (user.city && user.city !== "''"
                          ? user.city + ', '
                          : '') +
                        (user.province && user.province !== "''"
                          ? user.province + ' '
                          : '') +
                        (user.postalCode && user.postalCode !== "''"
                          ? user.postalCode
                          : '')
                    }}
                    {{
                      user.streetAddress === "''" &&
                      user.city === "''" &&
                      user.province === "''" &&
                      user.postalCode === "''"
                        ? 'N/A'
                        : ''
                    }}
                  </p>
                </div>
              </div>
            </template>
          </template>
          <template v-if="!transaction">
            <template slot="header">
              <div class="card-icon">
                <md-icon>receipt_long</md-icon>
              </div>
              <h4 class="title">Transaction not found for current user</h4>
            </template>
          </template>
        </table-card>
      </div>
    </div>

    <div class="md-layout" v-if="loaded && transaction">
      <div class="md-layout-item md-size-100">
        <table-card>
          <template slot="header">
            <div class="card-icon">
              <md-icon>dynamic_feed</md-icon>
            </div>
            <h4 class="title">Product Details</h4>
          </template>

          <template slot="content">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <md-table
                  v-model="tableData"
                  table-header-color="blue"
                  class="billing-and-invoices-table"
                >
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Product Type">{{
                      item.productType
                    }}</md-table-cell>
                    <md-table-cell md-label="Industry">{{
                      item.industry
                    }}</md-table-cell>
                    <md-table-cell md-label="Market Area">{{
                      item.marketArea
                    }}</md-table-cell>
                    <md-table-cell md-label="Price">{{
                      item.price
                    }}</md-table-cell>
                  </md-table-row>
                </md-table>
                <br />
                <h4
                  class="title order-total text-right"
                  v-if="tableData.length"
                >
                  <b>Order Total: ${{ cartTotal }}</b>
                </h4>
                <div v-if="!tableData.length">
                  There are no cart item data for this transaction
                </div>
                <br />
              </div>
            </div>
          </template>
        </table-card>
      </div>
    </div>
  </div>
</template>

<script>
import { TableCard, PulseLoader } from '@/components';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'transaction-details',
  components: {
    TableCard,
    PulseLoader,
  },
  data() {
    return {
      tableData: [],
      transaction: null,
      cartTotal: 0,
      cart: null,
      user: null,
      loaded: false,
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
  },
  methods: {
    getTransaction: async function() {
      this.transaction = null;
      this.user = null;
      this.loaded = false;
      const options = {
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
        },
      };
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/transaction',
          {},
          {
            params: {
              session_id: currentSession,
              transaction_id: this.$route.params.tid,
            },
          },
          options
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/transaction" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { transaction, user } = res.data;
          this.transaction = transaction;
          this.user = user;
          this.parseCartData();
          this.loaded = true;
        });
    },
    getTransactionPDF: async function() {
      const options = {
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
        },
      };
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/transaction/pdf',
          {},
          {
            params: {
              session_id: currentSession,
              transaction: this.$route.params.tid,
            },
          },
          options
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/transaction/pdf" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          let url = res.data.url;
          window.open(url, '_blank');
        });
    },
    parseCartData: async function() {
      let parsedData = [];
      this.cartTotal = 0;

      for (let item of this.transaction.cart.cart_items) {
        parsedData.push({
          productType: item.profile.title,
          industry: item.profile.industry,
          marketArea: item.profile.area,
          price: '$' + item.price,
        });

        this.cartTotal = this.cartTotal + item.price;
      }

      this.tableData = parsedData;
    },
  },
  async created() {
    await this.getTransaction();
  },
};
</script>
